<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38.7 38" style="enable-background:new 0 0 38.7 38;" xml:space="preserve">

<g>
	<g transform="translate(1 1)">
		<circle class="outer-circle" cx="18" cy="18" r="18"/>
		<path class="moving-part" d="M36,18c0-9.9-8.1-18-18-18">
            <animateTransform  accumulate="none" additive="replace" attributeName="transform" calcMode="linear" dur="1s" fill="remove" from="0 18 18" repeatCount="indefinite" restart="always" to="360 18 18" type="rotate">
            </animateTransform>
		</path>
	</g>
</g>
</svg>
